export enum NadajPrzesylkeType {
  POSIADAM_ETYKIETE = 'POSIADAM_ETYKIETE',
  STWORZ_NOWA_PRZESYLKE = 'STWORZ_NOWA_PRZESYLKE',
}

export enum SposobNadaniaType {
  NADAJ_W_PUNKCIE = 'NADAJ_W_PUNKCIE',
  ZAMOW_KURIERA = 'ZAMOW_KURIERA',
}

export enum SposobDoreczeniaType {
  DORECZENIE_DO_PUNKTU = 'DORECZENIE_DO_PUNKTU',
  DORECZENIE_PRZEZ_KURIERA = 'DORECZENIE_PRZEZ_KURIERA',
}

export enum PaczkaPaletaType {
  NADAJ_PACZKE = 'NADAJ_PACZKE',
  NADAJ_PALETE = 'NADAJ_PALETE',
}

export enum ScreenType {
  STRONA_GLOWNA = 'STRONA STRONA_GLOWNA',
  UTWORZ_PRZESYLKE = 'UTWORZ_PRZESYLKE',
  OPCJE_NADANIA = 'OPCJE_NADANIA',
  OPCJE_DORECZENIA = 'OPCJE_DORECZENIA',
}
